import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  buildModelFamilyIdsModelYearsPath,
  VehicleModel,
  VehicleEntities,
  buildForSaleYearsPath,
} from 'client/data/models/vehicle-v2';
import { VehicleGraphqlEntities } from 'client/data/models/vehicle-graphql';
import {
  getFilteredModelYears,
  getForSaleLinks,
  getModelYearsForSale,
} from 'site-modules/shared/utils/core-page/model-year-helpers';
import { YearLinksList } from './year-links-list/year-links-list';

function OtherForSaleYearsUI({
  vehicle: {
    year,
    model: { name: modelName, slug: modelSlug },
    make: { name: makeName, slug: makeSlug },
  },
  modelYears = null,
  forSaleYears = null,
  className = null,
  heading = null,
  headingClassName = 'heading-5 mb-0_75',
  renderEmptyHidden = false,
  isMobile = false,
}) {
  const yearsForSale = useMemo(
    () =>
      uniqBy(
        [
          ...getForSaleLinks({ forSaleYears, makeSlug, modelSlug }),
          ...getModelYearsForSale(getFilteredModelYears(modelYears, modelName)),
        ],
        'name'
      ).filter(({ name }) => name !== year),
    [forSaleYears, makeSlug, modelName, modelSlug, modelYears, year]
  );

  return (
    <YearLinksList
      years={yearsForSale}
      currentYear={year}
      makeName={makeName}
      modelName={modelName}
      className={className}
      heading={heading}
      headingClassName={headingClassName}
      renderEmptyHidden={renderEmptyHidden}
      isMobile={isMobile}
      linkTrackingId="see_other_years_srp"
      collapseTrackingId="see_other_years_srp"
      ariaLabelSuffix="years for sale"
      creativeId="for-sale-years-module"
    />
  );
}

OtherForSaleYearsUI.propTypes = {
  vehicle: VehicleGraphqlEntities.Vehicle.isRequired,
  modelYears: PropTypes.arrayOf(VehicleEntities.ModelYearByFamilyId),
  forSaleYears: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  heading: PropTypes.string,
  headingClassName: PropTypes.string,
  renderEmptyHidden: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export const OtherForSaleYears = connectToModel(OtherForSaleYearsUI, {
  modelYears: bindToPath(({ vehicle }) => buildModelFamilyIdsModelYearsPath(vehicle.modelFamilyIds), VehicleModel),
  forSaleYears: bindToPath(
    ({ vehicle }) => buildForSaleYearsPath({ make: vehicle.make.slug, model: vehicle.model.slug, year: vehicle.year }),
    VehicleModel
  ),
});
